import React from 'react'
import TextField from '../Components/TextField'
import Number from '../Components/Number'
import DateTimePicker from '../Components/DateTimePicker'
import DatePicker from '../Components/DatePicker'
import TimePicker from '../Components/TimePicker'
import List from '../Components/List'
import Note from '../Components/Note'

const styles = {
  contentSubtitle: {
    marginTop: '24px'
  },
  subtitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  }
}

function text (locals) {
  return (
    <div>
      <TextField
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        hasError={locals.hasError}
      />
    </div>
  )
}

function number (locals) {
  return (
    <div>
      <Number
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        hasError={locals.hasError}
      />
    </div>
  )
}

function dateTimePicker (locals) {
  return (
    <div>
      <DateTimePicker
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        hasError={locals.hasError}
      />
    </div>
  )
}

function datePicker (locals) {
  return (
    <div>
      <DatePicker
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        hasError={locals.hasError}
      />
    </div>
  )
}

function timePicker (locals) {
  return (
    <div>
      <TimePicker
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        hasError={locals.hasError}
      />
    </div>
  )
}

function getListInput (input) {
  let listInput = Object.keys(input).map(function (key) {
    return (<div key={key} value={key}>{input[key]}</div>)
  })
  return listInput
}

function embedsOne (locals) {
  return (
    <div style={styles.contentSubtitle}>
      <span
        style={styles.subtitle}
      >{locals.label}
      </span>
      <div>
        <fieldset>
          {getListInput(locals.inputs)}
        </fieldset>
      </div>
    </div>
  )
}

function belongsTo (locals) {
  return (
    <div>
      <List
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
        options={locals.options}
        hasError={locals.hasError}
      />
    </div>
  )
}

function note (locals) {
  return (
    <div>
      <Note
        label={locals.label}
        value={locals.value}
        onChange={(value) => locals.onChange(value)}
      />
    </div>
  )
}

export function getTemplates () {
  let templates = []
  templates['text'] = text
  templates['number'] = number
  templates['dateTimePicker'] = dateTimePicker
  templates['datePicker'] = datePicker
  templates['timePicker'] = timePicker
  templates['embedsOne'] = embedsOne
  templates['belongsTo'] = belongsTo
  templates['note'] = note
  return templates
}
